import React from 'react';
import { SDRMetricBar } from './SDRMetricBar';

interface SDRMetric {
  userId: string;
  userName: string;
  callsCount: number;
  callsDuration: number;
}

interface SDRMetricSectionProps {
  title: string;
  metrics: SDRMetric[];
  type: 'count' | 'duration';
}

export const SDRMetricSection: React.FC<SDRMetricSectionProps> = ({ 
  title, 
  metrics, 
  type 
}) => {
  const isTime = type === 'duration';
  const sortedMetrics = [...metrics].sort((a, b) => {
    const aVal = isTime ? a.callsDuration : a.callsCount;
    const bVal = isTime ? b.callsDuration : b.callsCount;
    return bVal - aVal;
  });

  // Limit to top 5 for 1080p fit
  const topMetrics = sortedMetrics.slice(0, 5);
  const maxValue = topMetrics.length > 0 
    ? Math.max(...topMetrics.map(m => isTime ? m.callsDuration : m.callsCount))
    : 0;

  return (
    <div className="mb-6 2xl:mb-10">
      <h3 className="text-xl 2xl:text-3xl font-semibold text-slate-300 mb-3 2xl:mb-5 pb-2 2xl:pb-3 border-b border-slate-600/30">
        {title}
      </h3>
      {topMetrics.length > 0 ? (
        <div className="space-y-3">
          {topMetrics.map((metric) => (
            <SDRMetricBar
              key={metric.userId}
              userName={metric.userName}
              value={isTime ? metric.callsDuration : metric.callsCount}
              maxValue={maxValue}
              isTime={isTime}
            />
          ))}
        </div>
      ) : (
        <div className="text-slate-500 text-center py-4 text-sm">
          No data available
        </div>
      )}
    </div>
  );
};